import { MenuItem, Select, SelectProps } from "@material-ui/core";
import { AppVersionPlatform } from "../../../../graphql/models";

export type AppPlatformPickerProps = SelectProps;

const platforms = Object.values(AppVersionPlatform);

export default function AppPlatformPicker(props: AppPlatformPickerProps) {
  const { ...selectProps } = props;

  return (
    <Select {...selectProps}>
      {platforms.map((p) => (
        <MenuItem value={p}>{p}</MenuItem>
      ))}
    </Select>
  );
}
